import React from 'react';
import { MainPinata } from '../../constants/assets';
import { deviceMotionFunction, deviceOrientationFunction } from './movementFunctions';

const Pinata = ({
    changeMode,
    gameStarted,
    gameStartedBefore,
    motionAlreadyDetected,
    startGameBefore,
    winTheGame}) => {

    const pinataStyle = gameStarted ? {
        width: "90%",
        maxWidth: "300px",
        transform: "none",
        left: "10%"
    } : {};
    const classGameStarted = gameStarted ? 'game-started' : '';
    let pinataObject = null;
    let touchTimes = 0;
    let lastNum = 0;
    let timeR = 0;

    const endTheGame = () => {
        window.removeEventListener('devicemotion', thisDeviceMotionFunction);
        window.removeEventListener('deviceorientation', thisDeviceOrientationFunction);
        window.removeEventListener('touchmove', thisDeviceOnTouchMoveFunction);
        winTheGame();
    };
    const thisDeviceMotionFunction = (event) => {
        if(timeR === 5) {
            const { strong, lastNumR  } = deviceMotionFunction(event);
            lastNum = lastNumR;
            if(strong >= 125) {
                endTheGame();
            } else if (strong > 20) {
                pinataObject.style.bottom = `${Math.floor(Math.random() * 57)}%`;
                pinataObject.style.left = `${Math.floor(-20 + Math.random() * (80 - 20))}%`;
            }
        } else {
            timeR = timeR + 1;
        }
    };
    const thisDeviceOrientationFunction = (event) => {
        if(timeR === 5) {
            const { strong, lastNumR  } = deviceOrientationFunction(event);
            lastNum = lastNumR;
            if(strong >= 125) {
                endTheGame();
            } else if (strong > 20) {
                pinataObject.style.bottom = `${Math.floor(Math.random() * 57)}%`;
                pinataObject.style.left = `${Math.floor(-20 + Math.random() * (80 - 20))}%`;
            }
        } else {
            timeR = timeR + 1;
        }
    };
    const thisDeviceOnTouchMoveFunction = () => {
        touchTimes = touchTimes + 1;
        pinataObject.style.bottom = `${Math.floor(Math.random() * 57)}%`;
        pinataObject.style.left = `${Math.floor(-20 + Math.random() * (80 + 1 - 20))}%`;
        if(touchTimes === 95) {
            endTheGame();
        }
    };
    const thisChangeIfStillOnZero = () => {
        if(lastNum === 0) {
            changeMode();
            window.removeEventListener('devicemotion', thisDeviceMotionFunction);
            window.removeEventListener('deviceorientation', thisDeviceOrientationFunction);
            window.addEventListener('touchmove', thisDeviceOnTouchMoveFunction);
        } else {
            motionAlreadyDetected();
        }
    };
    const initListeners = () => {
        if(window.DeviceMotionEvent) {
            window.addEventListener('devicemotion', thisDeviceMotionFunction);
        } else if(window.DeviceOrientationEvent) {
            window.addEventListener('deviceorientation', thisDeviceOrientationFunction);
        }
        setTimeout(() => {
            startGameBefore();
        }, 0);
        setTimeout(() => {
            thisChangeIfStillOnZero();
        }, 400);
    };

    if(gameStarted && !gameStartedBefore) {
        pinataObject = document.getElementById('pinatatoplay');
        initListeners();
    }

    return <MainPinata customID="pinatatoplay" customClass={classGameStarted} customStyle={pinataStyle} />;
}

export default Pinata;
